import {gql, useMutation, useQuery} from "@apollo/client";
import {getUnauthorizedUser} from "../../GraphQL/AuthorizationQuery";
import {authorizeUser} from "../../GraphQL/AuthorizationMutation";
import React, {useEffect} from "react";
import {useAppDispatch} from "../../redux/hooks";
import {setIsAppLoading} from "../../redux/slices/content/contentSlice";
import {toast} from "react-toastify";
import Button from "../../Atoms/Button";

export const Autorisierung = () => {
    const dispatch = useAppDispatch();

    const { data: unauthorizedUserData, loading: unauthorizedUserLoading, error: unauthorizedUserError } = useQuery(getUnauthorizedUser, {
        variables: {
            token: localStorage.getItem('token')
        },
        fetchPolicy: 'network-only'
    });
    const [authorizeUserFunc, { data: authorizeUserData, loading: authorizeUserLoading, error: authorizeUserError }] = useMutation(authorizeUser)

    const [unauthUserData, setUnauthUserData] = React.useState<any[]>([]);

    useEffect(() => {
        if (authorizeUserData) {
            toast('Nutzer wurde erfolgreich authorisiert!')
        }
    }, [authorizeUserData])

    useEffect(() => {
        if (unauthorizedUserData && !unauthorizedUserLoading) {
            setUnauthUserData(unauthorizedUserData.getUnauthorizedUser)
        }
    }, [unauthorizedUserData])

    useEffect(() => {
        if (unauthorizedUserLoading) {
            dispatch(setIsAppLoading({
                isAppLoading: true,
                loadingText: 'Nutzer werden geladen...'
            }))
        } else {
            dispatch(setIsAppLoading({
                isAppLoading: false,
                loadingText: ''
            }))
        }
    }, [unauthorizedUserLoading])

    useEffect(() => {
        if (authorizeUserLoading) {
            dispatch(setIsAppLoading({
                isAppLoading: true,
                loadingText: 'Nutzer werden authorisiert...'
            }))
        } else {
            dispatch(setIsAppLoading({
                isAppLoading: false,
                loadingText: ''
            }))
        }
    }, [authorizeUserLoading])

    useEffect(() => {
        if (unauthorizedUserError) {
            toast('Es gab einen Fehler beim Laden der Nutzer')
        }
    }, [unauthorizedUserError])

    useEffect(() => {
        if (authorizeUserError) {
            toast('Es gab einen Fehler beim Authorisieren des Nutzers')
        }
    }, [authorizeUserError])

    const authoriseUser = async (userId: number) => {
        await authorizeUserFunc({
            variables: {
                userId: Number(userId),
                token: localStorage.getItem('token')
            },
            refetchQueries: [{
                query: getUnauthorizedUser,
                variables: {
                    token: localStorage.getItem('token')
                }
            }]
        })
    }

    const renderOneUser = (userObject: any) => {
        return (
            <div className='row mt-3 authorisation-row'>
                <div className='col-2'>
                    {userObject.userId}
                </div>
                <div className='col-4'>
                    {userObject.userEmail}
                </div>
                <div className='col-4'>
                    {userObject.userName}
                </div>
                <div className='col-1'>
                    <Button onClick={ async() => await authoriseUser(userObject.userId)}>Authorisieren</Button>
                </div>
            </div>
        )
    }

    const renderAllUser = () => {
        const html = [];
        for (const unauthUser of unauthUserData) {
            html.push(renderOneUser(unauthUser))
        }

        return html;
    }

    return (
        <div>
            <div className='row justify-content-center mt-3'>
                <div className='col-10 adventure-container'>
                    <div className='row mt-3'>
                        <div className='col-2'>
                            ID
                        </div>
                        <div className='col-4'>
                            E-Mail
                        </div>
                        <div className='col-4'>
                            Name
                        </div>
                    </div>
                    { renderAllUser() }
                </div>
            </div>
        </div>
    )
}